(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["history-cards"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const cards = document.querySelectorAll(".history-card");

  cards.forEach(card => {
    card.addEventListener("mouseenter", function() {
      cards.forEach(c => c.classList.remove("open"));
      card.classList.add("open");
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const section = document.querySelector('.reviews-slider__wrapper');
  if (!section) return;

  const slideshow = section.querySelector('slideshow-component[ref="reviewsSlider"]');
  if (!slideshow) return;

  const scroller = slideshow.querySelector('slideshow-slides');
  const slides = Array.from(scroller.querySelectorAll('slideshow-slide'));
  if (!slides.length) return;

  // Initial positioning
  slides.forEach((s, i) => {
    s.style.position = "absolute";
    s.style.top = "0";
    s.style.left = "0";
    s.style.width = "100%";
    s.style.visibility = "visible";
    s.style.transform = i === 0 ? "translateX(0)" : "translateX(100%)";
    s.style.transition = "transform 0.65s ease-in-out";
  });

  let current = 0;
  
function setHeight() {
  const h = Math.max(...slides.map(s => {
    const el = s.querySelector('.review-slide__bubble') || s;
    return el.scrollHeight;  // Use FULL internal height
  }));
  scroller.style.height = h + "px";
}

  setHeight();
  setTimeout(setHeight, 200);
  window.addEventListener('resize', setHeight);

  // arrows ONLY inside this section
  const nextBtn = section.querySelector('[ref="next"]');
  const prevBtn = section.querySelector('[ref="previous"]');

  function updateArrows() {
    if (current === 0) {
      prevBtn.disabled = true;
      prevBtn.classList.add('disabled');
    } else {
      prevBtn.disabled = false;
      prevBtn.classList.remove('disabled');
    }

    if (current === slides.length - 1) {
      nextBtn.disabled = true;
      nextBtn.classList.add('disabled');
    } else {
      nextBtn.disabled = false;
      nextBtn.classList.remove('disabled');
    }
  }

  updateArrows();

  function goTo(idx, dir) {
    if (idx < 0 || idx >= slides.length || idx === current) return;

    const out = slides[current];
    const incoming = slides[idx];

    incoming.style.transform = dir === 'next' ? "translateX(100%)" : "translateX(-100%)";
    void incoming.offsetWidth;

    out.style.transform = dir === 'next' ? "translateX(-100%)" : "translateX(100%)";
    incoming.style.transform = "translateX(0)";

    current = idx;
    updateArrows();
    setHeight();
  }

  function next() { goTo(current + 1, 'next'); }
  function prev() { goTo(current - 1, 'prev'); }

  nextBtn.addEventListener('click', (e) => {
    e.preventDefault(); e.stopPropagation();
    next();
  });

  prevBtn.addEventListener('click', (e) => {
    e.preventDefault(); e.stopPropagation();
    prev();
  });
});

  } catch(e) { console.error(e); }
})();
})();
